/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Button, Header, Modal, Icon, Grid, Divider, Comment, Segment, Container, Label } from 'semantic-ui-react'
import ProductDetailsInfo from './productDetailsInfo'
import TyreDetailsInfo from './tyreDetailsInfo'
import InvoiceInfo from './invoiceInfo'
import ReadAxios from '../../axiosComponent/read'
import moment from 'moment'
const JobcardModal = (props) => {
    const [jobcardInfo, setjobcardInfo] = useState([])
    useEffect(() => {
        ReadAxios({ url: 'fleet/jobcard/getJobCards', readItems: { jobCardId: props.spId } })
            .then((result) => {
                setjobcardInfo(result)
                // console.log(result)
            })
            .catch(err => console.log(err))

    }, [props.spId])

    return (
        <Modal centered={false}
            open={props.modalOpen}
            onClose={props.handleClose}>
            <Modal.Header>
                <Header as="label" size="small" className="p-bold-500" color="grey"> Jobcard Details</Header>
            </Modal.Header>
            {jobcardInfo.map((object) => (
                <Modal.Content>
                    <Modal.Description>
                        <Segment size="small">
                            <Header><Header size="tiny" as="label" className="p-bold-500" color="blue">Basic Details</Header></Header>
                            <Grid centered columns="4">
                                <Grid.Row>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" color="grey" className="p-bold-500">Jobcard Number</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" className="p-bold-500">{object.jobCardno}</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" color="grey" className="p-bold-500">Jobcard Type</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" className="p-bold-500">{object.jb_type ? object.jb_type.jobCardType : ''}</Header>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" color="grey" className="p-bold-500">Reference Number</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" className="p-bold-500">{object.refNo}</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" color="grey" className="p-bold-500">Vehicle Number</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" className="p-bold-500">{object.vehicle_obj ? object.vehicle_obj.vehicleNo : ''}</Header>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" color="grey" className="p-bold-500">Branch</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" className="p-bold-500">{object.branch_obj ? object.branch_obj.branchName : ''}</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" color="grey" className="p-bold-500">Meter Reading</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" className="p-bold-500">{object.meterReading}</Header>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" color="grey" className="p-bold-500">Vehicle In Date</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" className="p-bold-500">{object.vehicleInDate ? moment(object.vehicleInDate, 'YYYY-MM-DD').format("DD-MM-YYYY") : ''}</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" color="grey" className="p-bold-500">Vehicle Out Date</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" className="p-bold-500">{object.vehicleOutDate ? moment(object.vehicleOutDate, 'YYYY-MM-DD').format("DD-MM-YYYY") : ''}</Header>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" color="grey" className="p-bold-500">Vendor</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Header as="p" size="tiny" className="p-bold-500">{object.vendor_obj ? object.vendor_obj.vendorName : ''}</Header>
                                    </Grid.Column>
                                    <Grid.Column />
                                    <Grid.Column />
                                </Grid.Row>
                            </Grid>
                        </Segment>
                        {jobcardInfo.jb_invoice === null ? '' : <InvoiceInfo getBillInfo={jobcardInfo} />}
                        <Segment hidden={object.jb_battery === null ? true : false}>
                            <Container fluid className="w3-white w3-round p-2 m-2">
                                <Header size="small" as="label" className="p-bold-500" color="blue">Battery Details</Header>
                                <Grid columns="4" className="pl-3">
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Header as="p" size="tiny" color="grey" className="p-bold-500">Battery Number</Header>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Header as="p" size="tiny" className="p-bold-500">{object.jb_battery ? object.jb_battery.serialNo : ''}</Header>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Container>
                        </Segment>
                        <TyreDetailsInfo onlyDisplay={true} hideDiv={object.jb_tyres.length === 0 ? true : false} getTyreInfo={jobcardInfo} />
                        <ProductDetailsInfo onlyDisplay={true} hideDiv={object.jb_product_services.length > 0 ? object.jb_product_services[0].psId === 0 ? true : false : true} getProductInfo={jobcardInfo} />
                        <Segment>
                            <Comment.Group>
                                <Header size="small" as="label" className="p-bold-500" color="blue"> <Icon size="mini" name="attach" /> Attachment(s) added</Header>
                                <Divider fitted />
                                <Comment.Author as='label' className="p-bold-500">Notes</Comment.Author>
                                <Comment.Text className="w3-text-grey">{object.remarks}</Comment.Text>
                            </Comment.Group>
                        </Segment>
                        <Label color="blue" basic size="mini" hidden={object.document === null ? true : false} onClick={() => window.open(`${object.document}`, '_blank')} className="overhere"> <Icon name="download" /> Vendor Invoice </Label>
                    </Modal.Description>
                </Modal.Content>
            ))}
            <Modal.Actions>
                <Button onClick={props.handleClose} size="tiny" primary>
                    Ok
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

export default JobcardModal
